import React, { useState, useEffect } from "react";
import { View, StyleSheet, Text, Platform } from "react-native";
import appStyles from "../../appStyles";

export default function ManaMinutesDuration(props) {
  const { minutes, suffix, showBraces = false, showZero = false } = props;
  const [duration, setDuration] = useState({});

  // ------------------------------------- DURATION -------------------------------------
  useEffect(() => {
    const hours = Math.floor(minutes / 60);
    const m = Math.floor(minutes % 60);

    let d = {};
    if (hours >= 0) d.hours = hours;
    if (minutes >= 0) d.minutes = m;

    setDuration(d);
  }, [minutes]);

  const warningsStyleText =
    !props.disableWarnings && duration.hours >= 10 ? styles.warningText : {};

  return (
    <View style={appStyles.row}>
      {showBraces ? <Text style={styles.duration}>(</Text> : null}
      {duration.hours || showZero ? (
        <View style={appStyles.row}>
          <Text style={[styles.duration, props.style, warningsStyleText]}>
            {duration.hours}
          </Text>
          <Text style={[styles.label, props.style, warningsStyleText]}>h</Text>
        </View>
      ) : null}
      {duration.minutes ? (
        <View style={appStyles.row}>
          <Text style={[styles.duration, props.style, warningsStyleText]}>
            {duration.hours ? " " : ""}
            {duration.minutes}
          </Text>
          <Text style={[styles.label, props.style, warningsStyleText]}>m</Text>
        </View>
      ) : null}
      {showBraces ? <Text style={styles.duration}>)</Text> : null}
      {suffix ? <Text style={styles.labelLight}>{suffix}</Text> : null}
    </View>
  );
}

const styles = StyleSheet.create({
  duration: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "#2D3142",
  },
  label: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    paddingTop: 3,
  },
  labelLight: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 10,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#2D3142",
    paddingTop: 3,
  },
  warningText: {
    color: "#DD5F43",
  },
});
